import * as yup from "yup";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

export default yup.object().shape({
  [fieldTypes.STATUS]: yup.object()
    .required(translate(null, "pre_intake.fields.status.errors", "required"))
    .nullable(),
});
